export default {
    newDesign: true,
    title: "Kodland'den 11.500₺ burs fırsatı! | Kodland",
    downtimeUrl: "https://www.kodland.org/tr",

    parameters: {
        landing_id: "TrQMn",
        segment: 12,
    },
    ageRules: {
    min: 5,
    max: 12,
  },
    startPage: {
        title:
            "3 soruyu cevaplayarak çocuğunuzun bursa uygun olup olmadığını öğrenin.",
        subtitle:
            "Başvuru süreci yalnızca 2 dakikadır.",
        image: {
            url: "/welcome/tr_scholarship_v3_desk.png",
            style: {
                height: "100%",
                "max-height": "100vh",
            },
        },
        imageMobile: {
            url: "/welcome/tr_scholarship_v3_mob.png",
            style: {
                width: "100%",
            },
        },
        button: "🚀 Başlayın",
    },
    stopPage: {
        image: "/welcome/quizV2/no-computer.png",
        title: "Eğitim platformumuza güvendiğiniz için teşekkür ederiz!",
        subtitle:
            "Maalesef, tablet veya telefonlar derslerimizi kullanmak için uygun değildir. Bir sonraki derslerimizde sizi görmekten mutluluk duyacağız!",
    },
    quizRotateBySteps: {
        1: {
            question: "Çocuğunuzun ilgi alanları nelerdir?",
            answers: [
                "🎮 Oyun tasarımı",
                "💻 Kodlama",
                "✏️ Çizim / animasyon",
                "🌐 Web tasarımı",
                "🧠 Mantık / matematik",
                "🎯 Emin değilim, keşfetmek istiyorum"
            ],
        },
        2: {
            question: "Kodland ile çocuğunuz dijital beceriler kazanır, kendi oyununu veya web sitesini yapar, portföy oluşturur ve birebir eğitim alır.",
            subtitle: "Çocuğunuzun bu fırsatlardan yararlanmasını ister misiniz?",
            answers: [
                "🙂 Evet", 
                "🤔 Muhtemelen",    
                "😕 Emin değilim",
            ],
        },
        3: {
            title: "Çocuğunuz kaç yaşında?",
            type: "age",
            button: "İleri 🚀",
        },
        4: {
            question: "Evinizde bilgisayar/dizüstü bilgisayar var mı?",
            subtitle: "Ücretsiz derse katılmak için çocuğunuzun bilgisayar veya dizüstü bilgisayar (telefon değil) ve sabit internet bağlantısı olması gerekir.",
            answers: [
                "💻 Evet, evimizde var",
                {
                    answer: "❌ Hayır, evimizde yok",
                    stopAnswer: true,
                },
            ],
        },
        5: {
            question: "Çocuğunuzun eğitiminde sizin için en önemli olan şey nedir?",
            answers: [
                "😄 İnteraktif ve eğlenceli aktiviteler",
                "🚀 Eğitim kalitesi",
                "👩‍🦳 Bireysel yaklaşım",
                "💰 Fiyat/kalite oranı",
                "👩‍🏫 Uzman öğretmen"
            ],
        },
        6: {
            typeInfo: "loaderScreen",
            sliderImages: [
                "/welcome/tr_math_scholarship_review1_desk.png",
                "/welcome/tr_math_scholarship_review2_desk.png",
                "/welcome/tr_math_scholarship_review3_desk.png",
            ],
            sliderImagesMobile: [
                "/welcome/tr_math_scholarship_review1_mob.png",
                "/welcome/tr_math_scholarship_review2_mob.png",
                "/welcome/tr_math_scholarship_review3_mob.png",
            ],
            textLoader: "%93 kontenjan doldu — acele edin!",
            titleLoader: 'Başvurunuz değerlendiriliyor…',
            subtitleLoader: "⭐ 4,8 / 5 — 50.000’den fazla değerlendirmeye dayanıyor",
            duration: 15000
        },
        7: {
            title: "Tebrikler! Ön değerlendirmeyi geçtiniz! 🎉",
            typeInfo: "congrats",
            subtitle:
                "Bir sonraki adım: Kodland temsilcisiyle kısa bir tanışma toplantısı.",
            button: "📆 Rezervasyon yapın",
        },
        8: {
            title: "3600₺ değerinde burs kazanma fırsatını kaçırmayın!",
            type: "one-page-contacts",
            subtitle: "Sadece 30 kişilik kontenjan kaldı. Burs yalnızca Kodland kursları için geçerlidir.",
            button: "Neredeyse bitti 🔥",
        },
        9: {
            title: "",
            type: "timeslot",
            subtitle: "",
            button: "",
        },
        10: {
            title:
                "Teşekkürler! Ücretsiz deneme dersiniz başarıyla planlandı. 🎉",
            typeInfo: "pc-laptop",
            subtitle:
                "Derse katılmak için lütfen masaüstü veya dizüstü bilgisayar kullanın ve ders boyunca çocuğunuza eşlik etmeyi unutmayın. Deneme dersinin bireysel ve kişiye özel olduğunu hatırlatmak isteriz.",
            button: "Başka neler var?",
        },
        11: {
            title: "Deneme dersinizden önce e-posta ve WhatsApp üzerinden iletişimde kalacağız. 📞",
            typeInfo: "whatsapp",
            subtitle:
                "Dersinizden 24 saat önce bir hatırlatma göndereceğiz ve 2 saat öncesinde katılımınızı onaylamanızı isteyeceğiz. İletişim kurmamız, dersinizin planlandığı gibi gerçekleşmesi için önemlidir.",
            button: "Başka neler var?",
        },
        12: {
            title: "Ders platformumuzda gerçekleşecek 💻",
            typeInfo: "classroom",
            subtitle:
              "WhatsApp ve e-posta yoluyla bir bağlantı ve özel bir kod alacaksınız. Sadece bağlantıya tıklayın, doğrudan derse yönlendirileceksiniz. Ekstra uygulama veya indirme gerekmiyor.",
            button: "Anladım ✅",
        }
    },
};
